import { CSSObject } from "@emotion/core";
import { EmotionStyles } from "../../../interfaces/emotion";
import { breakpointMixins } from "../../../styles/breakpoints";
import { colors } from "../../../styles/colors";
import { variables } from "../../../styles/variables";
import { textStyles } from "../../../styles/type";

const { spacing } = variables;

const productLayoutBase: CSSObject = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gridGap: `${spacing.raw.large * 2}rem`,
  rowGap: `${spacing.raw.large * 2}rem`,

  [breakpointMixins.lg]: {
    gridTemplateColumns: "1fr 1fr 1fr"
  }
};

export const styles: EmotionStyles = {
  productListContainer: {
    display: "flex",
    flexDirection: "column",
    marginBottom: spacing.large,
    [breakpointMixins.md]: {
      flexDirection: "row",
      justifyContent: "space-between"
    }
  },

  productList: {
    listStyleType: "none",
    padding: 0
  },
  productListWithFilters: {
    "& h4": {
      lineHeight: 1.15
    },
    "& h4 a": {
      ...textStyles.bodyM
    },
    [breakpointMixins.lg]: {
      paddingLeft: spacing.large
    }
  },

  productList_product: { ...productLayoutBase, paddingBottom: spacing.large },
  productList_vertical: productLayoutBase,
  productList_horizontal: {
    display: "product"
  },
  productPreviewItem: {
    marginBottom: spacing.large,
    width: "100%",
    [breakpointMixins.md]: {
      marginBottom: 0
    }
  },
  product_horizontal: {
    marginBottom: spacing.large,
    paddingBottom: spacing.medium,
    borderBottom: `1px solid ${colors.lightGrey}`,
    [breakpointMixins.md]: {
      paddingBottom: spacing.large,
      marginBottom: spacing.large
    }
  },
  productLast: {
    borderBottomWidth: 0
  },
  productHeading_horizontal: {
    marginBottom: spacing.large
  },
  productTitleLink: {
    textDecoration: "none",
    ...textStyles.headingXs,
    fontStyle: "normal"
  },
  price: {
    ...textStyles.bodyS
  },
  brand: {
    display: "block",
    marginBottom: spacing.xSmall
  }
};

export const productFilterListStyles: EmotionStyles = {
  container: {
    position: "sticky",
    top: 0,
    paddingTop: spacing.small,
    alignSelf: "start",
    background: colors.white,
    width: "100%",
    zIndex: 40,
    [breakpointMixins.md]: {
      marginRight: spacing.medium,
      top: spacing.small,
      paddingTop: 0,
      paddingRight: spacing.medium,
      borderRight: `1px solid ${colors.lightGrey}`,
      width: "auto"
    }
  }
};

export const productFilterStyles: EmotionStyles = {
  heading: {
    ...textStyles.bodyS,
    lineHeight: 1,
    display: "flex",
    alignItems: "center",
    "& svg": {
      marginLeft: spacing.small
    },
    [breakpointMixins.md]: {
      ...textStyles.bodyXs,
      "& svg": {
        display: "none"
      }
    }
  },
  list: {
    listStyleType: "none",
    padding: 0,
    transition: "max-height 1s ease-in-out",
    overflow: "hidden",
    "& li": {
      display: "inline-block",
      marginRight: spacing.small
    },
    [breakpointMixins.md]: {
      maxHeight: 3000,
      overflow: "visible",
      "& li": {
        display: "block",
        margin: 0
      }
    }
  },
  listOpen_true: { maxHeight: 3000 },
  listOpen_false: { maxHeight: 0 },
  button: {
    ...textStyles.bodyXs,
    marginBottom: spacing.small,
    display: "flex",
    alignItems: "center"
  },
  icon: {
    marginLeft: spacing.small
  }
};
